import Icon from '../components/Icon.vue'

Icon.register({
  'book-reader': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M352 96C352 43 309 0 256 0S160 43 160 96 203 192 256 192 352 149 352 96zM233.6 241.1C174.3 204.8 78.2 194.8 29.8 192.1 13.6 191.1 0 203.5 0 219.1V441.9C0 456.3 11.6 468.2 26.5 469 70.2 471.3 158.5 479.7 219.5 510.4 228.9 515.1 240 508.7 240 498.6V252.6C240 247.9 237.7 243.6 233.6 241.1zM482.2 192.1C433.9 194.8 337.7 204.8 278.4 241.1 274.3 243.6 272 248.1 272 252.7V498.5C272 508.7 283.2 515.1 292.6 510.4 353.6 479.7 441.9 471.3 485.5 469 500.4 468.2 512 456.3 512 442V219.1C512 203.5 498.5 191.1 482.2 192.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/book-reader.js
// module id = 5nQn
// module chunks = 144